import React from "react";
import PropTypes from "prop-types";
import SVG from "theme/components/icons/base/SVG";

const CheckIcon = ({ color, ...props }) => (
    <SVG fill="none" {...props}>
        <path d="M1 8.5 6.6 14 15 3" stroke={color} strokeWidth="2" />
    </SVG>
);

CheckIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

CheckIcon.defaultProps = {
    color: "currentColor",
    height: "16px",
    viewBox: "0 0 16 16",
    width: "16px",
};

export default CheckIcon;
